import AuthService from "../../AuthService";

const floor = {
  getFloor(page) {
    return AuthService.get(`/service/floor?page=${page}`);
  },
  showFloor(id) {
    return AuthService.get(`/service/floor/${id}`);
  },
  createFloor(data) {
    return AuthService.post("/service/floor", data);
  },
  updateFloor(id, data) {
    return AuthService.put(`/service/floor/${id}`, data);
  },
  deleteFloor(id) {
    return AuthService.delete(`/service/floor/${id}`);
  },
  getFloorAll() {
    return AuthService.get("/service/get_floor_all");
  }
};
export default floor;
